import Api from 'core/api';
import useFetch from 'hooks/useFetch';
import useMutation from 'hooks/useMutation';
import { ensureArray } from 'utils/arrays';

export const USER_BOOLEANS_QUERY_KEY = 'slUsers.getUserBooleans';

const useUserBooleans = ({ enabled = true } = {}) => {
  const { data: userBooleans, isLoading } = useFetch({
    apiFunc: Api.slUsers.getUserBooleans,
    apiFuncName: USER_BOOLEANS_QUERY_KEY,
    options: {
      enabled,
      select: ({ data }) => ensureArray(data?.results),
    },
  });

  const { mutateAsync: updateUserBooleans } = useMutation({
    apiFunc: Api.slUsers.updateUserBooleans,
    invalidateQueries: [USER_BOOLEANS_QUERY_KEY],
  });

  const isUserBooleanSet = type =>
    ensureArray(userBooleans).some(({ name, value }) => name === type && value);

  return {
    userBooleans,
    updateUserBooleans,
    userBooleansLoading: isLoading,
    isUserBooleanSet,
  };
};

export default useUserBooleans;
